module.exports = __webpack_public_path__ + "Roboto-ThinItalic.11b5cc9584f2c007a229.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.ttf
// module id = 158
// module chunks = 10